import { useState } from "react";
import { Button, CheckboxControl, ErrorControl, Label, TextInput } from "@osago/ui";
import { AccordionSection } from "./AccordionSection";
import { COLORS, getProduct } from "@/shared/config/widget";
import { CHAN_MAX, PARTNER_ID_MAX } from "@/shared/lib/partnerParams";
import { ymEvent, YM } from "@/shared/lib/metrika";
import { useConfigurator } from "../model/configuratorContext";
import { CompaniesField } from "@/shared/ui/CompaniesField";
import { ColorField } from "./ColorField";
import { ProductField } from "./ProductField";

export function SettingsPanel() {
  const {
    colors,
    setColor,
    partnerId,
    setPartnerId,
    partnerIdLocked,
    chan,
    setChan,
    hidePromo,
    setHidePromo,
    hideTitle,
    setHideTitle,
    product,
    setProduct,
    companies,
    companiesCleared,
    setCompanies,
    reset,
  } = useConfigurator();
  const [touched, setTouched] = useState(false);

  const partnerError =
    touched && !partnerId.trim() ? "Укажите партнёрский ID" : "";

  return (
    <div className="flex flex-col gap-4">
      <AccordionSection title="Партнёр" defaultOpen>
        <TextInput
          label="Партнёрский ID"
          required
          value={partnerId}
          onChange={(v) => {
            setTouched(true);
            setPartnerId(v);
          }}
          placeholder="например, 1024"
          maxLength={PARTNER_ID_MAX}
          readOnly={partnerIdLocked}
          hasError={Boolean(partnerError)}
          rightSlot={
            partnerError ? <ErrorControl isOK={false} errorMessage={partnerError} /> : undefined
          }
        />
        <Label variant="hint" className="mt-1.5 block">
          Выдаётся при регистрации в партнёрской программе
        </Label>
        <div className="mt-3">
          <TextInput
            label="Chan ID"
            value={chan}
            onChange={setChan}
            placeholder="например, email"
            maxLength={CHAN_MAX}
          />
          <Label variant="hint" className="mt-1.5 block">
            Метка канала или площадки — для статистики в кабинете партнёра
          </Label>
        </div>
      </AccordionSection>

      <AccordionSection title="Продукт" defaultOpen>
        <ProductField value={product} onChange={setProduct} />
      </AccordionSection>

      {getProduct(product).supportsCompanies && (
        <AccordionSection title="Страховые компании">
          <Label variant="hint" className="mb-2.5 block">
            По умолчанию клиент видит предложения всех доступных СК. Отметьте компании, чтобы
            ограничить список.
          </Label>
          <CompaniesField
            selected={companies}
            cleared={companiesCleared}
            onChange={setCompanies}
          />
        </AccordionSection>
      )}

      <AccordionSection title="Отображение">
        <div className="flex flex-col gap-2.5">
          <CheckboxControl
            id="hide-promo"
            checked={hidePromo}
            onChange={setHidePromo}
            label="Скрыть картинку в блоке «Выбирай лучшие цены»"
          />
          {product === "pkasko" && (
            <CheckboxControl
              id="hide-title"
              checked={hideTitle}
              onChange={setHideTitle}
              label="Скрыть заголовок «Полис ПКаско»"
            />
          )}
        </div>
      </AccordionSection>

      <AccordionSection
        title="Цвета"
        defaultOpen
        action={
          <Button
            variant="link"
            className="text-xs"
            onClick={() => {
              reset();
              ymEvent(YM.RESET);
            }}
          >
            Сбросить
          </Button>
        }
      >
        <div className="flex flex-col gap-2">
          {COLORS.map((c) => (
            <ColorField
              key={c.key}
              label={c.label}
              value={colors[c.key]}
              fallback={c.fallback}
              onChange={(v) => setColor(c.key, v)}
            />
          ))}
        </div>
      </AccordionSection>
    </div>
  );
}
